// Minimal i18n dictionary. Add keys as needed.
export const SUPPORTED_LOCALES = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'de', label: 'Deutsch' },
  { code: 'it', label: 'Italiano' },
  { code: 'pt', label: 'Português' },
];

export const translations = {
  fr: {
    'brand.tagline': 'apprends la musique',
    'nav.dashboard': 'Tableau',
    'nav.library': 'Chansons',
    'nav.courses': 'Cours',
    'nav.playlists': 'Playlists',
    'nav.tutor': 'Maestro IA',
    'nav.community': 'Communauté',
    'nav.admin': 'Admin',
    'nav.pro': 'Passer Pro',
    'nav.member_pro': 'Membre Pro',
    'nav.challenge': 'Défi Hebdo',
    'nav.hall_of_fame': 'Salle des Champions',
    'nav.logout': 'Déconnexion',
    'auth.login': 'Se connecter',
    'auth.my_space': 'Mon espace',
    'landing.overline': 'du débutant au pro · tous instruments',
    'landing.hero1': 'Apprends les',
    'landing.hero_em': 'chansons',
    'landing.hero2': 'que tu aimes.',
    'landing.hero3': 'À ton rythme.',
    'landing.hero_desc': "Une bibliothèque vivante d'accords, tablatures et tutos vidéo — pensée pour la guitare, le piano, le chant, la batterie et la basse.",
    'landing.cta_start': 'Commencer gratuitement',
    'landing.cta_continue': 'Continuer',
    'landing.explore': 'Explorer les instruments',
    'landing.pick_instrument': 'Choisis ton instrument',
    'landing.each_instrument': 'Chaque instrument, un chemin dédié.',
    'landing.beginner_pro': 'Débutant → Pro',
    'dashboard.welcome': 'Bienvenue',
    'dashboard.hello': 'Bonjour,',
    'dashboard.subtitle': "Reprends là où tu t'es arrêté ou découvre une nouvelle chanson.",
    'dashboard.streak': 'Série',
    'dashboard.minutes': 'Temps de pratique',
    'dashboard.completed': 'Terminées',
    'dashboard.learning': 'En cours',
    'dashboard.recommended': 'Recommandé pour débuter',
    'dashboard.see_all': 'Voir tout →',
    'dashboard.your_badges': 'Tes badges',
    'dashboard.stuck': 'Coincé sur un passage ?',
    'dashboard.ask_maestro': 'Demande à Maestro, ton tuteur IA, pour des conseils personnalisés.',
    'dashboard.open_tutor': 'Ouvrir le tuteur',
    'pro.overline': 'Maestro Pro',
    'pro.title1': 'Débloque ta pratique.',
    'pro.title2': 'Sans limite.',
    'pro.free_trial': 'Essai gratuit de 7 jours. Annulable à tout moment.',
    'pro.monthly': 'Mensuel',
    'pro.yearly': 'Annuel',
    'pro.per_month': '/ mois',
    'pro.per_year': '/ an',
    'pro.flexible': 'Flexible, résilie à tout moment',
    'pro.save': 'Économise',
    'pro.best_offer': 'MEILLEURE OFFRE',
    'pro.start_trial': "Démarrer l'essai gratuit",
    'pro.coupon_placeholder': 'Code promo (ex: LAUNCH30)',
    'pro.coupon_apply': 'Appliquer',
    'pro.founding': 'Membres fondateurs · {n} places restantes à -30%',
    'pro.member': 'Tu es Membre Pro',
    'pro.status': 'Statut',
    'pro.renewal': 'Renouvellement le',
    'pro.cancel': "Annuler l'abonnement",
    'pro.cancel_scheduled': "Ton abonnement s'arrêtera à la fin de la période.",
    'challenge.title': 'Défi de la semaine',
    'challenge.leaderboard': 'Classement',
    'challenge.your_entry': 'Publie ta reprise dans la communauté avec le tag Défi Hebdo',
    'challenge.no_entries': 'Aucune reprise pour le moment. Sois le premier !',
    'challenge.vote': 'Voter',
    'challenge.voted': 'Voté ✓',
    'challenge.ends_in': 'Se termine dans',
    'community.share_practice': 'Partage ta pratique',
    'community.publish': 'Publier',
    'community.record_audio': 'Enregistrer une reprise (audio)',
    'community.record_video': 'Filmer une reprise (vidéo)',
    'community.add_comment': 'Ajouter un commentaire...',
    'common.close': 'Fermer',
    'common.cancel': 'Annuler',
    'common.save': 'Enregistrer',
    'common.create': 'Créer',
    'common.loading': 'Chargement...',
    'common.language': 'Langue',
  },
  en: {
    'brand.tagline': 'learn music',
    'nav.dashboard': 'Dashboard',
    'nav.library': 'Songs',
    'nav.courses': 'Courses',
    'nav.playlists': 'Playlists',
    'nav.tutor': 'Maestro AI',
    'nav.community': 'Community',
    'nav.admin': 'Admin',
    'nav.pro': 'Upgrade to Pro',
    'nav.member_pro': 'Pro Member',
    'nav.challenge': 'Weekly Challenge',
    'nav.hall_of_fame': 'Hall of Fame',
    'nav.logout': 'Log out',
    'auth.login': 'Log in',
    'auth.my_space': 'My space',
    'landing.overline': 'from beginner to pro · every instrument',
    'landing.hero1': 'Learn the',
    'landing.hero_em': 'songs',
    'landing.hero2': 'you love.',
    'landing.hero3': 'At your own pace.',
    'landing.hero_desc': 'A living library of chords, tabs and video tutorials for guitar, piano, voice, drums and bass.',
    'landing.cta_start': 'Start for free',
    'landing.cta_continue': 'Continue',
    'landing.explore': 'Explore instruments',
    'landing.pick_instrument': 'Pick your instrument',
    'landing.each_instrument': 'Each instrument, its own path.',
    'landing.beginner_pro': 'Beginner → Pro',
    'dashboard.welcome': 'Welcome',
    'dashboard.hello': 'Hello,',
    'dashboard.subtitle': 'Pick up where you left off or discover a new song.',
    'dashboard.streak': 'Streak',
    'dashboard.minutes': 'Practice time',
    'dashboard.completed': 'Completed',
    'dashboard.learning': 'In progress',
    'dashboard.recommended': 'Recommended for beginners',
    'dashboard.see_all': 'See all →',
    'dashboard.your_badges': 'Your badges',
    'dashboard.stuck': 'Stuck on a passage?',
    'dashboard.ask_maestro': 'Ask Maestro, your AI tutor, for personalized advice.',
    'dashboard.open_tutor': 'Open tutor',
    'pro.overline': 'Maestro Pro',
    'pro.title1': 'Unlock your practice.',
    'pro.title2': 'No limits.',
    'pro.free_trial': '7-day free trial. Cancel any time.',
    'pro.monthly': 'Monthly',
    'pro.yearly': 'Yearly',
    'pro.per_month': '/ month',
    'pro.per_year': '/ year',
    'pro.flexible': 'Flexible, cancel any time',
    'pro.save': 'Save',
    'pro.best_offer': 'BEST DEAL',
    'pro.start_trial': 'Start free trial',
    'pro.coupon_placeholder': 'Promo code (e.g., LAUNCH30)',
    'pro.coupon_apply': 'Apply',
    'pro.founding': 'Founding members · {n} spots left at -30%',
    'pro.member': "You're a Pro Member",
    'pro.status': 'Status',
    'pro.renewal': 'Renews on',
    'pro.cancel': 'Cancel subscription',
    'pro.cancel_scheduled': 'Your subscription will end at the end of the period.',
    'challenge.title': 'Weekly Challenge',
    'challenge.leaderboard': 'Leaderboard',
    'challenge.your_entry': 'Post your cover in the community with the Weekly Challenge tag',
    'challenge.no_entries': 'No entries yet. Be the first!',
    'challenge.vote': 'Vote',
    'challenge.voted': 'Voted ✓',
    'challenge.ends_in': 'Ends in',
    'community.share_practice': 'Share your practice',
    'community.publish': 'Publish',
    'community.record_audio': 'Record a cover (audio)',
    'community.record_video': 'Film a cover (video)',
    'community.add_comment': 'Add a comment...',
    'common.close': 'Close',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.create': 'Create',
    'common.loading': 'Loading...',
    'common.language': 'Language',
  },
  es: {
    'brand.tagline': 'aprende música',
    'nav.dashboard': 'Panel',
    'nav.library': 'Canciones',
    'nav.courses': 'Cursos',
    'nav.playlists': 'Playlists',
    'nav.tutor': 'Maestro IA',
    'nav.community': 'Comunidad',
    'nav.admin': 'Admin',
    'nav.pro': 'Hacerse Pro',
    'nav.member_pro': 'Miembro Pro',
    'nav.challenge': 'Reto Semanal',
    'nav.hall_of_fame': 'Salón de la Fama',
    'nav.logout': 'Salir',
    'auth.login': 'Entrar',
    'auth.my_space': 'Mi espacio',
    'landing.overline': 'de principiante a pro · todos los instrumentos',
    'landing.hero1': 'Aprende las',
    'landing.hero_em': 'canciones',
    'landing.hero2': 'que amas.',
    'landing.hero3': 'A tu ritmo.',
    'landing.hero_desc': 'Una biblioteca viva de acordes, tablaturas y tutoriales en video para guitarra, piano, voz, batería y bajo.',
    'landing.cta_start': 'Empezar gratis',
    'landing.cta_continue': 'Continuar',
    'landing.explore': 'Explorar instrumentos',
    'landing.pick_instrument': 'Elige tu instrumento',
    'landing.each_instrument': 'Cada instrumento, su camino.',
    'landing.beginner_pro': 'Principiante → Pro',
    'dashboard.welcome': 'Bienvenido',
    'dashboard.hello': 'Hola,',
    'dashboard.subtitle': 'Continúa donde lo dejaste o descubre una nueva canción.',
    'dashboard.streak': 'Racha',
    'dashboard.minutes': 'Tiempo',
    'dashboard.completed': 'Terminadas',
    'dashboard.learning': 'En curso',
    'dashboard.recommended': 'Recomendado para empezar',
    'dashboard.see_all': 'Ver todo →',
    'dashboard.your_badges': 'Tus insignias',
    'dashboard.stuck': '¿Atascado en un pasaje?',
    'dashboard.ask_maestro': 'Pregunta a Maestro, tu tutor IA.',
    'dashboard.open_tutor': 'Abrir el tutor',
    'pro.overline': 'Maestro Pro',
    'pro.title1': 'Desbloquea tu práctica.',
    'pro.title2': 'Sin límites.',
    'pro.free_trial': 'Prueba gratis de 7 días. Cancela cuando quieras.',
    'pro.monthly': 'Mensual',
    'pro.yearly': 'Anual',
    'pro.per_month': '/ mes',
    'pro.per_year': '/ año',
    'pro.flexible': 'Flexible, cancela cuando quieras',
    'pro.save': 'Ahorra',
    'pro.best_offer': 'MEJOR OFERTA',
    'pro.start_trial': 'Empezar prueba gratis',
    'pro.coupon_placeholder': 'Código promo (ej: LAUNCH30)',
    'pro.coupon_apply': 'Aplicar',
    'pro.founding': 'Miembros fundadores · quedan {n} lugares a -30%',
    'pro.member': 'Eres Miembro Pro',
    'pro.status': 'Estado',
    'pro.renewal': 'Renovación el',
    'pro.cancel': 'Cancelar suscripción',
    'pro.cancel_scheduled': 'Tu suscripción terminará al final del período.',
    'challenge.title': 'Reto de la semana',
    'challenge.leaderboard': 'Clasificación',
    'challenge.your_entry': 'Publica tu versión en la comunidad con la etiqueta Reto Semanal',
    'challenge.no_entries': 'Aún no hay entradas. ¡Sé el primero!',
    'challenge.vote': 'Votar',
    'challenge.voted': 'Votado ✓',
    'challenge.ends_in': 'Termina en',
    'community.share_practice': 'Comparte tu práctica',
    'community.publish': 'Publicar',
    'community.record_audio': 'Grabar cover (audio)',
    'community.record_video': 'Filmar cover (video)',
    'community.add_comment': 'Añadir un comentario...',
    'common.close': 'Cerrar',
    'common.cancel': 'Cancelar',
    'common.save': 'Guardar',
    'common.create': 'Crear',
    'common.loading': 'Cargando...',
    'common.language': 'Idioma',
  },
  de: {
    'brand.tagline': 'Musik lernen',
    'nav.dashboard': 'Dashboard',
    'nav.library': 'Songs',
    'nav.courses': 'Kurse',
    'nav.playlists': 'Playlists',
    'nav.tutor': 'Maestro KI',
    'nav.community': 'Community',
    'nav.admin': 'Admin',
    'nav.pro': 'Pro werden',
    'nav.member_pro': 'Pro-Mitglied',
    'nav.challenge': 'Wöchentl. Challenge',
    'nav.hall_of_fame': 'Ruhmeshalle',
    'nav.logout': 'Abmelden',
    'auth.login': 'Anmelden',
    'auth.my_space': 'Mein Bereich',
    'landing.overline': 'vom Anfänger zum Profi · alle Instrumente',
    'landing.hero1': 'Lerne die',
    'landing.hero_em': 'Songs',
    'landing.hero2': 'die du liebst.',
    'landing.hero3': 'In deinem Tempo.',
    'landing.hero_desc': 'Eine lebendige Bibliothek mit Akkorden, Tabulaturen und Video-Tutorials für Gitarre, Klavier, Gesang, Schlagzeug und Bass.',
    'landing.cta_start': 'Kostenlos starten',
    'landing.cta_continue': 'Weiter',
    'landing.explore': 'Instrumente entdecken',
    'landing.pick_instrument': 'Wähle dein Instrument',
    'landing.each_instrument': 'Jedes Instrument, sein Weg.',
    'landing.beginner_pro': 'Anfänger → Profi',
    'dashboard.welcome': 'Willkommen',
    'dashboard.hello': 'Hallo,',
    'dashboard.subtitle': 'Setze fort, wo du aufgehört hast, oder entdecke einen neuen Song.',
    'dashboard.streak': 'Serie',
    'dashboard.minutes': 'Übungszeit',
    'dashboard.completed': 'Fertig',
    'dashboard.learning': 'In Arbeit',
    'dashboard.recommended': 'Empfehlungen für Anfänger',
    'dashboard.see_all': 'Alle anzeigen →',
    'dashboard.your_badges': 'Deine Abzeichen',
    'dashboard.stuck': 'Bei einer Stelle festgefahren?',
    'dashboard.ask_maestro': 'Frage Maestro, deinen KI-Tutor.',
    'dashboard.open_tutor': 'Tutor öffnen',
    'pro.overline': 'Maestro Pro',
    'pro.title1': 'Deine Übung entfesseln.',
    'pro.title2': 'Ohne Limit.',
    'pro.free_trial': '7 Tage kostenlos testen. Jederzeit kündbar.',
    'pro.monthly': 'Monatlich',
    'pro.yearly': 'Jährlich',
    'pro.per_month': '/ Monat',
    'pro.per_year': '/ Jahr',
    'pro.flexible': 'Flexibel, jederzeit kündbar',
    'pro.save': 'Spare',
    'pro.best_offer': 'BESTES ANGEBOT',
    'pro.start_trial': 'Gratis-Testphase starten',
    'pro.coupon_placeholder': 'Gutscheincode (z. B. LAUNCH30)',
    'pro.coupon_apply': 'Anwenden',
    'pro.founding': 'Gründungsmitglieder · noch {n} Plätze mit -30%',
    'pro.member': 'Du bist Pro-Mitglied',
    'pro.status': 'Status',
    'pro.renewal': 'Erneuerung am',
    'pro.cancel': 'Abo kündigen',
    'pro.cancel_scheduled': 'Dein Abo endet am Ende der Periode.',
    'challenge.title': 'Wöchentliche Challenge',
    'challenge.leaderboard': 'Rangliste',
    'challenge.your_entry': 'Poste deine Version in der Community mit dem Tag Weekly Challenge',
    'challenge.no_entries': 'Noch keine Einträge. Sei der Erste!',
    'challenge.vote': 'Abstimmen',
    'challenge.voted': 'Gestimmt ✓',
    'challenge.ends_in': 'Endet in',
    'community.share_practice': 'Teile deine Übung',
    'community.publish': 'Veröffentlichen',
    'community.record_audio': 'Cover aufnehmen (Audio)',
    'community.record_video': 'Cover filmen (Video)',
    'community.add_comment': 'Kommentar hinzufügen...',
    'common.close': 'Schließen',
    'common.cancel': 'Abbrechen',
    'common.save': 'Speichern',
    'common.create': 'Erstellen',
    'common.loading': 'Lädt...',
    'common.language': 'Sprache',
  },
  it: {
    'brand.tagline': 'impara la musica',
    'nav.dashboard': 'Bacheca',
    'nav.library': 'Canzoni',
    'nav.courses': 'Corsi',
    'nav.playlists': 'Playlist',
    'nav.tutor': 'Maestro IA',
    'nav.community': 'Community',
    'nav.admin': 'Admin',
    'nav.pro': 'Passa a Pro',
    'nav.member_pro': 'Membro Pro',
    'nav.challenge': 'Sfida della Settimana',
    'nav.hall_of_fame': 'Sala della Fama',
    'nav.logout': 'Esci',
    'auth.login': 'Accedi',
    'auth.my_space': 'Il mio spazio',
    'landing.overline': 'dal principiante al pro · tutti gli strumenti',
    'landing.hero1': 'Impara le',
    'landing.hero_em': 'canzoni',
    'landing.hero2': 'che ami.',
    'landing.hero3': 'Al tuo ritmo.',
    'landing.hero_desc': 'Una libreria viva di accordi, tablature e tutorial video per chitarra, piano, voce, batteria e basso.',
    'landing.cta_start': 'Inizia gratis',
    'landing.cta_continue': 'Continua',
    'landing.explore': 'Esplora gli strumenti',
    'landing.pick_instrument': 'Scegli il tuo strumento',
    'landing.each_instrument': 'Ogni strumento, il suo percorso.',
    'landing.beginner_pro': 'Principiante → Pro',
    'dashboard.welcome': 'Benvenuto',
    'dashboard.hello': 'Ciao,',
    'dashboard.subtitle': 'Riprendi da dove eri o scopri una nuova canzone.',
    'dashboard.streak': 'Serie',
    'dashboard.minutes': 'Tempo',
    'dashboard.completed': 'Completate',
    'dashboard.learning': 'In corso',
    'dashboard.recommended': 'Consigliate per iniziare',
    'dashboard.see_all': 'Vedi tutto →',
    'dashboard.your_badges': 'I tuoi badge',
    'dashboard.stuck': 'Bloccato su un passaggio?',
    'dashboard.ask_maestro': 'Chiedi a Maestro, il tuo tutor IA.',
    'dashboard.open_tutor': 'Apri il tutor',
    'pro.overline': 'Maestro Pro',
    'pro.title1': 'Sblocca la tua pratica.',
    'pro.title2': 'Senza limiti.',
    'pro.free_trial': 'Prova gratuita di 7 giorni. Annulla quando vuoi.',
    'pro.monthly': 'Mensile',
    'pro.yearly': 'Annuale',
    'pro.per_month': '/ mese',
    'pro.per_year': '/ anno',
    'pro.flexible': 'Flessibile, annulla quando vuoi',
    'pro.save': 'Risparmia',
    'pro.best_offer': 'MIGLIOR OFFERTA',
    'pro.start_trial': 'Inizia la prova gratuita',
    'pro.coupon_placeholder': 'Codice promo (es. LAUNCH30)',
    'pro.coupon_apply': 'Applica',
    'pro.founding': 'Membri fondatori · restano {n} posti a -30%',
    'pro.member': 'Sei Membro Pro',
    'pro.status': 'Stato',
    'pro.renewal': 'Rinnovo il',
    'pro.cancel': 'Annulla abbonamento',
    'pro.cancel_scheduled': "L'abbonamento terminerà a fine periodo.",
    'challenge.title': 'Sfida settimanale',
    'challenge.leaderboard': 'Classifica',
    'challenge.your_entry': 'Pubblica la tua cover nella community con il tag Sfida Settimanale',
    'challenge.no_entries': 'Ancora nessuna cover. Sii il primo!',
    'challenge.vote': 'Vota',
    'challenge.voted': 'Votato ✓',
    'challenge.ends_in': 'Termina tra',
    'community.share_practice': 'Condividi la tua pratica',
    'community.publish': 'Pubblica',
    'community.record_audio': 'Registra una cover (audio)',
    'community.record_video': 'Filma una cover (video)',
    'community.add_comment': 'Aggiungi un commento...',
    'common.close': 'Chiudi',
    'common.cancel': 'Annulla',
    'common.save': 'Salva',
    'common.create': 'Crea',
    'common.loading': 'Caricamento...',
    'common.language': 'Lingua',
  },
  pt: {
    'brand.tagline': 'aprenda música',
    'nav.dashboard': 'Painel',
    'nav.library': 'Músicas',
    'nav.courses': 'Cursos',
    'nav.playlists': 'Playlists',
    'nav.tutor': 'Maestro IA',
    'nav.community': 'Comunidade',
    'nav.admin': 'Admin',
    'nav.pro': 'Assinar Pro',
    'nav.member_pro': 'Membro Pro',
    'nav.challenge': 'Desafio Semanal',
    'nav.hall_of_fame': 'Salão da Fama',
    'nav.logout': 'Sair',
    'auth.login': 'Entrar',
    'auth.my_space': 'Meu espaço',
    'landing.overline': 'do iniciante ao pro · todos os instrumentos',
    'landing.hero1': 'Aprenda as',
    'landing.hero_em': 'músicas',
    'landing.hero2': 'que você ama.',
    'landing.hero3': 'No seu ritmo.',
    'landing.hero_desc': 'Uma biblioteca viva de acordes, tablaturas e tutoriais em vídeo para violão, piano, voz, bateria e baixo.',
    'landing.cta_start': 'Começar grátis',
    'landing.cta_continue': 'Continuar',
    'landing.explore': 'Explorar instrumentos',
    'landing.pick_instrument': 'Escolha seu instrumento',
    'landing.each_instrument': 'Cada instrumento, seu caminho.',
    'landing.beginner_pro': 'Iniciante → Pro',
    'dashboard.welcome': 'Bem-vindo',
    'dashboard.hello': 'Olá,',
    'dashboard.subtitle': 'Continue de onde parou ou descubra uma nova música.',
    'dashboard.streak': 'Sequência',
    'dashboard.minutes': 'Tempo',
    'dashboard.completed': 'Concluídas',
    'dashboard.learning': 'Em curso',
    'dashboard.recommended': 'Recomendadas para começar',
    'dashboard.see_all': 'Ver tudo →',
    'dashboard.your_badges': 'Seus emblemas',
    'dashboard.stuck': 'Travado em um trecho?',
    'dashboard.ask_maestro': 'Pergunte ao Maestro, seu tutor IA.',
    'dashboard.open_tutor': 'Abrir o tutor',
    'pro.overline': 'Maestro Pro',
    'pro.title1': 'Desbloqueie sua prática.',
    'pro.title2': 'Sem limites.',
    'pro.free_trial': '7 dias grátis. Cancele quando quiser.',
    'pro.monthly': 'Mensal',
    'pro.yearly': 'Anual',
    'pro.per_month': '/ mês',
    'pro.per_year': '/ ano',
    'pro.flexible': 'Flexível, cancele quando quiser',
    'pro.save': 'Economize',
    'pro.best_offer': 'MELHOR OFERTA',
    'pro.start_trial': 'Começar teste grátis',
    'pro.coupon_placeholder': 'Cupom (ex: LAUNCH30)',
    'pro.coupon_apply': 'Aplicar',
    'pro.founding': 'Membros fundadores · restam {n} vagas com -30%',
    'pro.member': 'Você é Membro Pro',
    'pro.status': 'Status',
    'pro.renewal': 'Renovação em',
    'pro.cancel': 'Cancelar assinatura',
    'pro.cancel_scheduled': 'Sua assinatura termina no fim do período.',
    'challenge.title': 'Desafio da semana',
    'challenge.leaderboard': 'Classificação',
    'challenge.your_entry': 'Publique sua versão na comunidade com a tag Desafio Semanal',
    'challenge.no_entries': 'Ainda sem entradas. Seja o primeiro!',
    'challenge.vote': 'Votar',
    'challenge.voted': 'Votado ✓',
    'challenge.ends_in': 'Termina em',
    'community.share_practice': 'Compartilhe sua prática',
    'community.publish': 'Publicar',
    'community.record_audio': 'Gravar cover (áudio)',
    'community.record_video': 'Filmar cover (vídeo)',
    'community.add_comment': 'Adicionar um comentário...',
    'common.close': 'Fechar',
    'common.cancel': 'Cancelar',
    'common.save': 'Salvar',
    'common.create': 'Criar',
    'common.loading': 'Carregando...',
    'common.language': 'Idioma',
  },
};
